export default __webpack_public_path__ + "static/media/02.a176bd55.png";